"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.dataSelectorId = exports.DEFAULT_TEXTS = exports.DEFAULT_MAX_HEIGHT_COLUMN = exports.DEFAULT_MAX_WIDTH_COLUMN = exports.MAX_WIDTH_MENU = exports.INT_HEIGHT_FOOTER_MENU = void 0;
const helpers_1 = require("../../../helpers");
const INT_MAX_WIDTH_MENU = 720;
const INT_MAX_HEIGHT_MENU = 800;
const INT_PADDING_LEFT_MENU = parseInt(helpers_1.SPACING_S, 10);
const INT_PADDING_RIGHT_MENU = parseInt(helpers_1.SPACING_M, 10);
const INT_PADDING_TOP_MENU = parseInt(helpers_1.SPACING_S, 10);
exports.INT_HEIGHT_FOOTER_MENU = parseInt(helpers_1.SPACING_XL, 10);
exports.MAX_WIDTH_MENU = `${INT_MAX_WIDTH_MENU}px`;
exports.DEFAULT_MAX_WIDTH_COLUMN = `${INT_MAX_WIDTH_MENU - INT_PADDING_LEFT_MENU - INT_PADDING_RIGHT_MENU}px`;
exports.DEFAULT_MAX_HEIGHT_COLUMN = `${INT_MAX_HEIGHT_MENU -
    INT_PADDING_TOP_MENU -
    exports.INT_HEIGHT_FOOTER_MENU -
    2 * parseInt(helpers_1.BASE_BORDER_WIDTH, 10)}px`;
exports.DEFAULT_TEXTS = {
    selectAll: 'Select All',
    clearAll: 'Clear All'
};
exports.dataSelectorId = {
    mainControl: 'categorized-choice-main-control',
    selectAll: 'categorized-choice-select-all-control',
    clearAll: 'categorized-choice-clear-all-control',
    partIdCheckbox: 'categorized-choice-checkbox'
};
//# sourceMappingURL=constants.js.map